import React from 'react';
import { useTranslation } from 'react-i18next';
import PrinterNumberField from '../../../inputs/PrinterNumberField';
import { PRINTER_NUMBER_MAX_LENGTH } from '../../../../constants';
import styles from './MobilePrinter.css';

interface ManualPrinterInputProps {
  printerNumber: string;
  onPrinterNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  translationRoot: string;
  inputRootClass?: string;
}

const ManualPrinterInput: React.FC<ManualPrinterInputProps> = ({
  printerNumber,
  onPrinterNumberChange,
  translationRoot,
  inputRootClass,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.printerNumberInput}>
      <label htmlFor="printerNumber" className={styles.printerInputLabel}>
        {t(`${translationRoot}.MANUALLY_ADD_MOBILE_PRINTER`)}
      </label>
      <PrinterNumberField
        id="printerNumber"
        label={t(`${translationRoot}.PRINTER_PLACEHOLDER`)}
        value={printerNumber}
        onChange={onPrinterNumberChange}
        maxLength={PRINTER_NUMBER_MAX_LENGTH}
        inputRootClass={inputRootClass}
      />
    </div>
  );
};

export default React.memo(ManualPrinterInput);
